/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Confirm_DeleteInputs */



/**
* | output |
* | --- |
* | "Delete {count} events in {group}?" |
*
* @param {Assistant_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_confirm_delete = /** @type {((inputs: Assistant_Confirm_DeleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Confirm_DeleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Supprimer les événements ${i?.count} dans ${i?.group} ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Ereignisse in ${i?.group} löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eliminare gli eventi ${i?.count} in ${i?.group}?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить события ${i?.count} в ${i?.group}?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Eliminar los eventos ${i?.count} en ${i?.group}?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除 ${i?.group} 中的 ${i?.count} 事件？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group}内の${i?.count}イベントを削除しますか？`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} इवेंट्स को डिलीट करें?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Excluir eventos ${i?.count} em ${i?.group}?`)
	return /** @type {LocalizedString} */ (`Delete ${i?.count} events in ${i?.group}?`)
});